import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';
import {accountService, useGetAccount} from "app/utils/services/accountService";

export const cardService = {
  getCardData: async () => {
    const result = await httpClient.post<any>('/api-web/v1/main/card_list');

    return result;
  },

  changeSmsNotif: async (data: any) => {
    const result = await httpClient.post<any>('/api-web/v1/main/change_card_sms_notification', data.data);

    return result;
  },
  setCardName: async (data: { data: any }): Promise<any> => {
    const result = await httpClient.post<any>('/api-web/v1/main/card_list', data.data);

    return result;
  },
  changeCardStatus: async (data: any) => {
    const result = await httpClient.post<any>('/api-web/v1/main/change_card_status', data.data);

    return result;
  },
};

export const useGetCard = () => {
  const {
    isFetching: isFetchingGetDataCard,
    isLoading: isLoadingGetDataCard,
    data: dataGetCard,
    refetch: refetchGetDataCard,
  } = useQuery(['getCardData'], cardService.getCardData, {
    cacheTime: 0,
    enabled: false,
  });

  return { isFetchingGetDataCard, isLoadingGetDataCard, dataGetCard, refetchGetDataCard };
};

export const useSetCardName = () => {
  const { refetchGetDataCard } = useGetCard();

  const {
    isLoading: isLoadingSetNameCard,
    data: dataSetNameCard,
    mutate: setCardNameMutation,
  } = useMutation(['setCardName'], (data: any) => cardService.setCardName(data), {
    onSuccess: () => {
      refetchGetDataCard();
    },
  });

  return { isLoadingSetNameCard, dataSetNameCard, setCardNameMutation };
};

export const useChangeSmsNotif = () => {
  const { refetchGetDataCard } = useGetCard();
  const {
    isLoading: isLoadingSmsNotif,
    data: dataSmsNotif,
    mutate: smsNotifMutation,
  } = useMutation(['changeSmsNotif'], (data: { data: any }) => cardService.changeSmsNotif(data), {
    onSuccess: () => {
      refetchGetDataCard();
    },
  });

  return {
    isLoadingSmsNotif,
    smsNotifMutation,
    dataSmsNotif,
  };
};

export const useChangeCardStatus = () => {
  const { refetchGetDataCard } = useGetCard();
  const {
    isLoading: isLoadingCardStatus,
    data: dataCardStatus,
    mutate: cardStatusMutation,
  } = useMutation(['changeSmsNotif'], (data: { data: any }) => cardService.changeCardStatus(data), {
    onSuccess: () => {
      refetchGetDataCard();
    },
  });

  return {
    isLoadingCardStatus,
    cardStatusMutation,
    dataCardStatus,
  };
};
